import { DatePicker } from "antd";
import moment from "moment";
import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadDashboardData } from "../../../redux/actions/dashboard/getDashboardDataAction";
import { loadAllPurchase } from "../../../redux/actions/purchase/getPurchaseAction";
import { loadAllSale } from "../../../redux/actions/sale/getSaleAction";
import NewDashboardCard from "../../Card/Dashboard/NewDashboardCard";
import { CACHE_KEYS, getCachedDateFilter, setCachedDateFilter } from "../../../utils/dateFilterCache";

const DemoLine = () => {
	const [startdate, setStartdate] = useState(() => {
		const c = getCachedDateFilter(CACHE_KEYS.DASHBOARD);
		return c ? moment(c.startdate) : moment().startOf("month");
	});
	const [enddate, setEnddate] = useState(() => {
		const c = getCachedDateFilter(CACHE_KEYS.DASHBOARD);
		return c ? moment(c.enddate) : moment().endOf("month");
	});
	const dispatch = useDispatch();

	const cardInformation = useSelector(
		(state) => state.dashboard.list?.cardInfo
	);

	const { RangePicker } = DatePicker;

	useEffect(() => {
		dispatch(loadDashboardData({ startdate, enddate }));
		dispatch(
			loadAllPurchase({
				page: 1,
				limit: 100,
				startdate: startdate,
				enddate: enddate,
			})
		);
		dispatch(
			loadAllSale({
				page: 1,
				limit: 100,
				startdate: startdate,
				enddate: enddate,
				user: "",
			})
		);
	}, []);

	const onCalendarChange = (dates) => {
		const newStartdate = dates?.[0] ? (dates[0].format ? dates[0].format("YYYY-MM-DD") : moment(dates[0]).format("YYYY-MM-DD")) : null;
		const newEnddate = dates?.[1] ? (dates[1].format ? dates[1].format("YYYY-MM-DD") : moment(dates[1]).format("YYYY-MM-DD")) : null;
		const startVal = newStartdate || (startdate?.format ? startdate.format("YYYY-MM-DD") : startdate);
		const endVal = newEnddate || (enddate?.format ? enddate.format("YYYY-MM-DD") : enddate);

		setStartdate(newStartdate ? moment(newStartdate) : startdate);
		setEnddate(newEnddate ? moment(newEnddate) : enddate);
		if (startVal && endVal) setCachedDateFilter(CACHE_KEYS.DASHBOARD, { startdate: startVal, enddate: endVal });
		dispatch(
			loadDashboardData({
				startdate: startVal,
				enddate: endVal,
			})
		);

		dispatch(
			loadAllPurchase({
				page: 1,
				limit: 100,
				startdate: startVal,
				enddate: endVal,
			})
		);

		dispatch(
			loadAllSale({
				page: 1,
				limit: 100,
				startdate: startVal,
				enddate: endVal,
				user: "",
			})
		);
	};

	return (
		<Fragment>
			<div className="dashboard-header-row dashboard-header-row-compact">
				<RangePicker
					onCalendarChange={onCalendarChange}
					defaultValue={[startdate, enddate]}
					className="range-picker"
					format="DD-MMM-YYYY"
					size="small"
				/>
			</div>

			<NewDashboardCard information={cardInformation} />
		</Fragment>
	);
};

export default DemoLine;
